var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 pb-12"},[_c('AdminTitle',{attrs:{"title":"Reporting"}}),_c('div',[_c('employer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }